import { Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/auth";
import { HomePage } from "./pages/home";
import { StoresPage } from "./pages/admin/stores";
import { StoreDetailsPage } from "./pages/admin/store-details";
import { CampaignsPage } from "./pages/admin/campaigns";
import { QuestionsManagementPage } from "./pages/admin/questions-management";
import { LoginPage } from "./pages/login";
import { NotFoundPage } from "./pages/not-found";
import { ProtectedRoute } from "./components/protected-route";
import { StoreQuestionsPage } from "./pages/store/questions";
import { StoreMenuPage } from "./pages/store/menu";

export const App = () => {
  const routes = [
    {
      path: "/",
      element: (
        <ProtectedRoute>
          <HomePage />
        </ProtectedRoute>
      ),
    },
    {
      path: "/inicio",
      element: (
        <ProtectedRoute>
          <StoreMenuPage />
        </ProtectedRoute>
      ),
    },
    {
      path: "/questionario/:campaignId",
      element: (
        <ProtectedRoute>
          <StoreQuestionsPage />
        </ProtectedRoute>
      ),
    },
    {
      path: "/concessionarias",
      element: (
        <ProtectedRoute>
          <StoresPage />
        </ProtectedRoute>
      ),
    },
    {
      path: "/concessionarias/:storeId",
      element: (
        <ProtectedRoute>
          <StoreDetailsPage />
        </ProtectedRoute>
      ),
    },
    {
      path: "/campanhas",
      element: (
        <ProtectedRoute>
          <CampaignsPage />
        </ProtectedRoute>
      ),
    },
    {
      path: "/campanhas/:campaignId",
      element: (
        <ProtectedRoute>
          <QuestionsManagementPage />
        </ProtectedRoute>
      ),
    },
    {
      path: "/entrar",
      element: <LoginPage />,
    },
    {
      path: "*",
      element: <NotFoundPage />,
    },
  ];

  return (
    <AuthProvider>
      <Routes>
        {routes.map((route, index) => (
          <Route key={index} path={route.path} element={route.element} />
        ))}
      </Routes>
    </AuthProvider>
  );
};
